// src/App.js
import React, { useState, useEffect, useRef } from 'react'; // Ã¢â€ Â Agregar useRef
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/Home';
import Story from './pages/Story';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import VerifyEmail from './pages/auth/VerifyEmail';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import KrumsPage from './pages/KrumsPage';
import AdminPage from './pages/AdminPage';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import UpdatePrompt from './components/UpdatePrompt';
import PWAUpdater from './components/PWAUpdater';
import { getConfiguracionPublica } from './services/api';
import ModoMantenimiento from './components/ModoMantenimiento';
import FeedbackButton from './components/FeedbackButton';
import MisReportes from './pages/MisReportes';
import PreciosPage from './pages/PreciosPage';
import PagoExitoso from './pages/PagoExitoso';
import PagoFallido from './pages/PagoFallido';
import PagoPendiente from './pages/PagoPendiente';
import './App.css'; 


// Componente para rutas protegidas
const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div className="loading-screen">Cargando...</div>;
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Componente para rutas de administraciÃƒÂ³n
	const AdminRoute = ({ children }) => {
	  const { isAuthenticated, loading, user } = useAuth();

	  if (loading) {
		return <div className="loading-screen">Cargando...</div>;
	  }

	  if (!isAuthenticated) {
		return <Navigate to="/login" />;
	  }

	  if (user?.rol !== 'admin') {
		return <Navigate to="/" />;
	  }

	  return children;
	};

function AppContent() {
  const { user, logout } = useAuth();

  return (
    <div className="App">
      {/* Ã¢Å“â€¦ USAR EL COMPONENTE HEADER */}
      <Header />

	  <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
		 <Route path="/registro" element={<Register />} /> {/* Ã¢â€ Â NUEVA RUTA */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/" element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        } />
        <Route path="/story/:id" element={
          <PrivateRoute>
            <Story />
          </PrivateRoute>
        } />
        <Route path="/dashboard" element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        } />
        <Route path="/profile" element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        } />
	  <Route path="/krums" element={
		  <PrivateRoute>
			<KrumsPage />
		  </PrivateRoute>
		} />
	  <Route path="/admin" element={
		  <AdminRoute>
			<AdminPage />
		  </AdminRoute>
		} />
	  <Route path="/mis-reportes" element={
		  <PrivateRoute>
			<MisReportes />
		  </PrivateRoute>
		} />
	  <Route path="/precios" element={<PreciosPage />} />
	  <Route path="/planes" element={<PreciosPage />} />
	  <Route path="/pago-exitoso" element={<PagoExitoso />} />
	  <Route path="/pago-fallido" element={<PagoFallido />} />
	  <Route path="/pago-pendiente" element={<PagoPendiente />} />
	  </Routes>
	  <PWAInstallPrompt />
	<FeedbackButton />
      <footer>
		    <img src="/logo-kreamun-small.png" alt="KREAMUN" className="footer-logo" />
        <p>© 2026 KREAMUN - En alg&uacute;n lugar del multiverso, un mundo espera ser creado... por ti.</p>
      </footer>
      <UpdatePrompt />
	  <PWAUpdater />

    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}


function Header() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [adminDropdownOpen, setAdminDropdownOpen] = useState(false);
  const [modoMantenimiento, setModoMantenimiento] = useState(false);
  
  const dropdownRef = useRef(null);
  const adminDropdownRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    // Cerrar dropdowns al cerrar el menÃƒÂº
    if (!menuOpen) {
      setDropdownOpen(false);
      setAdminDropdownOpen(false);
    }
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
    setAdminDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
    // Si abrimos un dropdown, cerramos el otro
    if (!dropdownOpen) setAdminDropdownOpen(false);
  };

  const toggleAdminDropdown = () => {
    setAdminDropdownOpen(!adminDropdownOpen);
    if (!adminDropdownOpen) setDropdownOpen(false);
  };

  const handleNavigation = () => {
    closeMenu();
  };

  const handleLogout = () => {
    logout();
    closeMenu();
    navigate('/');
  };

  // Cerrar dropdowns al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (adminDropdownRef.current && !adminDropdownRef.current.contains(event.target)) {
        setAdminDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
		  

	// NUEVO useEffect para modo mantenimiento (AGREGA ESTO)
	useEffect(() => {
	  const checkMantenimiento = async () => {
		try {
		  const response = await getConfiguracionPublica('modo_mantenimiento');
		  if (response.data.valor === 'true') {
			setModoMantenimiento(true);
		  }
		} catch (error) {
		  console.error('Error verificando mantenimiento:', error);
		}
	  };
	  checkMantenimiento();
	}, []);
		  

	const [showKrumsModal, setShowKrumsModal] = useState(false);
	const [krumsError, setKrumsError] = useState('');

	useEffect(() => {
	  const handleKrumsInsuficientes = (event) => {
		setKrumsError(event.detail.error || 'Saldo insuficiente');
		setShowKrumsModal(true);
	  };

	  window.addEventListener('krums-insuficientes', handleKrumsInsuficientes);
	  return () => window.removeEventListener('krums-insuficientes', handleKrumsInsuficientes);
	}, []);
		  
		  
  if (modoMantenimiento) {
	  return <ModoMantenimiento />;
	}
		  
  return (
    <header className="header">
      <div className="header-content">
      	<div className="logo-container" onClick={() => { navigate('/'); closeMenu(); }}>
      		<img src="/logo-kreamun.png" alt="KREAMUN" className="logo" />
		    <h1 style={{ marginBottom: '-9px' }}>REAMUN</h1>
    	</div>
        
        {/* BotÃƒÂ³n hamburguesa */}
        <button className={`hamburger ${menuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        {/* MenÃƒÂº de navegaciÃƒÂ³n */}
		<nav className={`nav-menu ${menuOpen ? 'active' : ''}`}>
		  {user ? (
			// Usuario autenticado
			<>
			  <Link to="/" className="nav-link">
				<span className="menu-icon">🏠</span> Inicio
			  </Link>

			  {/* Dropdown de usuario */}
			  <div className="user-dropdown" ref={dropdownRef}>
				<button onClick={toggleDropdown} className="dropdown-toggle">
				  <span className="user-avatar">✨</span>
				  <span className="user-name">{user.username}</span>
				  <span className="dropdown-arrow">{dropdownOpen ? '▲' : '▼'}</span>
				</button>

				{dropdownOpen && (
				  <div className="dropdown-menu">
					<Link to="/dashboard" className="dropdown-item" onClick={handleNavigation}>
					  <span className="menu-icon">🌌</span> Mis Universos
					</Link>
					<Link to="/profile" className="dropdown-item" onClick={handleNavigation}>
					  <span className="menu-icon">👤</span> Mi Perfil
					</Link>
					<Link to="/krums" className="dropdown-item" onClick={handleNavigation}>
					  <span className="menu-icon">💎</span> Forja de Krums
					</Link>
					<Link to="/planes" className="dropdown-item" onClick={handleNavigation}>
					  <span className="menu-icon">💰</span> Planes y Precios
					</Link>
					<Link to="/mis-reportes" className="dropdown-item" onClick={handleNavigation}>
					  <span className="menu-icon">📢</span> Mis Reportes
					</Link>
					<div className="dropdown-divider"></div>
					<button onClick={handleLogout} className="dropdown-item logout-btn">
					  <span className="menu-icon">🚪</span> Cerrar sesión
					</button>
				  </div>
				)}
			  </div>

			  {/* Admin link (si es admin) */}
			  {user?.rol === 'admin' && (
				<div className="admin-dropdown" ref={adminDropdownRef}>
				  <button onClick={toggleAdminDropdown} className="dropdown-toggle admin-toggle">
					<span className="menu-icon">⚙️</span> Admin 
					<span className="dropdown-arrow">{adminDropdownOpen ? '▲' : '▼'}</span>
				  </button>

				  {adminDropdownOpen && (
					<div className="dropdown-menu admin-menu">
					  <Link to="/admin" className="dropdown-item" onClick={handleNavigation}>
						<span className="menu-icon">📊</span> Dashboard
					  </Link>
					</div>
				  )}
				</div> 
			  )}
			</> 
		  ) : (
			// Usuario no autenticado
			<>
			  <Link to="/" className="nav-link">
				<span className="menu-icon">🏠</span> Inicio
			  </Link>
			  <Link to="/login" className="nav-link">
				<span className="menu-icon">🔑</span> Iniciar sesión
			  </Link>
			  <Link to="/precios" className="nav-link">
				<span className="menu-icon">💰</span> Precios
			  </Link>
			  <Link to="/register" className="nav-link">
				<span className="menu-icon">📝</span> Registrarse
			  </Link>
			</>
		  )}
		</nav>

		{/* Modal de Krums insuficientes */}
		{showKrumsModal && (
		  <div className="modal-overlay">
			<div className="modal-content krums-modal">
			  <h3>⚠️ Saldo insuficiente</h3>
			  <p>{krumsError}</p>
			  <div className="modal-buttons">
				<Link to="/krums" className="btn btn-primary" onClick={() => setShowKrumsModal(false)}>
				  💰 Comprar Krums
				</Link>
				<button className="btn btn-secondary" onClick={() => setShowKrumsModal(false)}>
				  Cerrar
				</button>
			  </div>
			</div>
		  </div>
		)}	

      </div>
    </header>
  );
}

window.addEventListener('error', (event) => {
  console.log('Error capturado:', event);
});

export default App;